import { menu as input__misc } from './input_misc';

export const menu = {
  name: (<div className="text"><u>I</u>nput</div>),
  trigger: 'i',
  children: {
    ...input__misc
  }
}
